var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96 3.75 2.64 7.73l-.32.38.32.4 6.87 8.76.49.62.49-.62 6.87-8.75.32-.41-.32-.38-3.32-3.98H5.96ZM6.54 5h2.29L7.15 7.5h-2.7L6.55 5Zm4.63 0h2.29l2.09 2.5h-2.7L11.17 5ZM10 5.53l1.33 1.97H8.67L10 5.53ZM4.4 8.75h2.63L8.52 14 4.39 8.75Zm3.92 0h3.34L10 14.57 8.32 8.75Zm4.65 0h2.64l-4.13 5.23 1.49-5.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGem);
export default ForwardRef;